import React from 'react';
import { TextInput, required, SelectInput, ReferenceInput } from 'react-admin';

import { FormGroupGrid, GridForm, GridInput } from '../../../components/GridForm';
import { TimeZoneSelect } from '../../../components/inputs/TimeZoneSelect';
import { PortInput } from 'components/inputs/PortInput';

export const TerminalsEditForm = (props) => (
    <GridForm {...props}>
        <FormGroupGrid>
            <GridInput sm={2} component={TextInput} source='id' disabled />
            <GridInput sm={10} component={TextInput} source='name' validate={[required()]} autoFocus />
            <GridInput sm={7} component={TextInput} source='short_name' />
            <GridInput sm={5} component={TextInput} source='account_code' />
        </FormGroupGrid>

        <FormGroupGrid>
            <GridInput sm={4} component={TextInput} source='guid' disabled />
            <GridInput sm={4} component={TextInput} source='address' />
            <GridInput sm={4} component={TimeZoneSelect} source='time_zone' validate={[required()]} />
            <GridInput sm={4} component={PortInput} source='reception_port' emptyText="" label="resources.terminal.fields.reception_port"/>
            <GridInput sm={4} disabled={true}>
                <ReferenceInput source="duty_manager_id" reference="users" disabled={true}>
                    <SelectInput optionText={(record) => `${record.first_name} ${record.last_name}`} />
                </ReferenceInput>
            </GridInput>
        </FormGroupGrid>
    </GridForm>
);
